"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediafileGeneratorMediafileFilter = void 0;
var MediafileGeneratorMediafileFilter = (function () {
    function MediafileGeneratorMediafileFilter(availableMediafileIds, lastRotationIds) {
        this.availableMediafileIds = new Set(availableMediafileIds);
    }
    MediafileGeneratorMediafileFilter.prototype.filter = function (mediafiles) {
        var _this = this;
        var filteredMediafiles = mediafiles.filter(function (mediafile) { return _this.availableMediafileIds.has(mediafile.id) && mediafile.type === 0; });
        return filteredMediafiles;
    };
    return MediafileGeneratorMediafileFilter;
}());
exports.MediafileGeneratorMediafileFilter = MediafileGeneratorMediafileFilter;
//# sourceMappingURL=MediafileGeneratorMediafileFilter.js.map